var render = function (_h,_vm) {var _c=_vm._c;return _c('div',{staticClass:"sub-banner"},[_c('div',{staticClass:"credit",class:_vm.$options.methods.getCredit(_vm.props.userInfo) > 0
        ? 'credit--positive'
        : 'credit--negative'},[_c('span',{domProps:{"textContent":_vm._s(
        _vm.$options.methods.getCreditMessage(_vm.props.userInfo, _vm.props.currency)
      )}})])])}
var staticRenderFns = []

export { render, staticRenderFns }